import { render, staticRenderFns } from "./CustomMediaControl.vue?vue&type=template&id=022fc9b1"
import script from "./CustomMediaControl.vue?vue&type=script&lang=js"
export * from "./CustomMediaControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports